import { useNavigate } from 'react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { isAxiosError } from 'axios';

import { createProposal, createProposalFromTutor } from 'api/v1/requests/bulletins';
import { addNotification } from 'notifications';
import { chatKeys } from 'modules/ChatV2/api/queries';
import { buildChatUrl } from 'utils/buildChatUrl';

export const useCreateProposal = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      bulletinId,
      data,
    }: {
      bulletinId: number;
      data: { tutor_profile_id: number; message: string };
    }) => createProposal(bulletinId, data),
    onSuccess: (response, variables) => {
      void queryClient.invalidateQueries({ queryKey: chatKeys.all });
      const chatId = response?.chat_id;
      const roomId = response?.room_id;
      const userId = response?.tutor_id;

      if (chatId) {
        navigate(
          buildChatUrl({
            chatId,
            roomId,
            userId,
            bulletinId: variables?.bulletinId,
            role: 'student',
          }),
          {
            state: { chatId, roomId, userId },
          },
        );
      } else {
        console.error('Бэкенд не вернул chat_id');
      }
    },
    onError: (error) => {
      let msg = 'Не удалось отправить приглашение';
      if (isAxiosError(error)) {
        const detail = (error.response?.data as { detail?: string } | undefined)?.detail;
        if (typeof detail === 'string' && detail.trim()) msg = detail;
      }
      addNotification(msg, 'error');
    },
  });
};

export const useCreateProposalFromTutor = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      data,
    }: {
      data: { bulletin_id: number; message: string; proposed_price: number };
      skipNavigate?: boolean;
    }) => createProposalFromTutor(data),
    onSuccess: (response, variables) => {
      void queryClient.invalidateQueries({ queryKey: chatKeys.all });
      void queryClient.invalidateQueries({ queryKey: ['tutor-trust-score', 'me'] });
      void queryClient.invalidateQueries({ queryKey: ['searchTutors'] });
      void queryClient.invalidateQueries({
        queryKey: ['bulletinPublic', variables.data.bulletin_id],
      });
      if (variables.skipNavigate) {
        return;
      }
      const chatId = response?.chat_id;
      const roomId = response?.room_id;

      if (chatId) {
        navigate(
          buildChatUrl({
            chatId,
            roomId,
            bulletinId: variables.data.bulletin_id,
            role: 'tutor',
          }),
          {
            state: { chatId, roomId },
          },
        );
      } else {
        console.error('Бэкенд не вернул chat_id');
      }
    },
    onError: (error) => {
      console.error('Ошибка при отправке предложения:', error);
    },
  });
};
